import { withHomepageRevamp } from '@/flags.server';
import type { InferGetServerSidePropsType } from 'next';
import dynamic from 'next/dynamic';

import { getCountryFromRequest } from '@/lib/geo/server';

import { useHomepageRevamp } from '@/hooks/useHomepageRevamp';

import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { LegacyHomepage } from '../components/HomepageV3/LegacyHomepage';

// The flag defaults to off, so the revamp tree stays out of the legacy visitor's payload.
const Homepage = dynamic(() => import('../components/Homepage').then(({ Homepage }) => Homepage));

export default function HomePage({
  showStocksAvailabilityBanner,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const homepageRevamp = useHomepageRevamp();

  if (!homepageRevamp) {
    return <LegacyHomepage showStocksAvailabilityBanner={showStocksAvailabilityBanner} />;
  }

  return (
    <div className="overflow-hidden h-fit">
      <Header isHomepage={true} hideSearch={false} />
      <Homepage />
      <div className="h-14" />
      <hr className="border-token-gray-300" />
      <Footer isHomepage={true} />
    </div>
  );
}

export const getServerSideProps = withHomepageRevamp(async (ctx) => {
  ctx.res.setHeader('Vary', 'X-Vercel-IP-Country');

  const showStocksAvailabilityBanner = getCountryFromRequest(ctx.req) === 'US';

  return { props: { showStocksAvailabilityBanner } };
});
